import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { TaskDescriptionAcknowledgementDTO } from '../dtos/project-tasks/task-description-acknowledgement.dto';

/**
 * TaskDescriptionAcknowledgementsHttpService - HTTP API layer for task description acknowledgement operations.
 *
 * Handles HTTP communication with the task description acknowledgement API endpoints.
 *
 * Scope: Global (`providedIn: 'root'`).
 *
 * Usage: Used by {@link TaskDescriptionAcknowledgementsDataService} to perform API calls.
 */
@Injectable({ providedIn: 'root' })
export class TaskDescriptionAcknowledgementsHttpService {
  private readonly httpClient = inject(HttpClient);

  public getAcknowledgements(taskId: string): Observable<TaskDescriptionAcknowledgementDTO[]> {
    return this.httpClient.get<TaskDescriptionAcknowledgementDTO[]>(
      `${environment.APIEndPoint}tasks/${taskId}/description-acknowledgements`
    );
  }

  public getAcknowledgement(taskId: string, acknowledgementId: string): Observable<TaskDescriptionAcknowledgementDTO> {
    return this.httpClient.get<TaskDescriptionAcknowledgementDTO>(
      `${environment.APIEndPoint}tasks/${taskId}/description-acknowledgements/${acknowledgementId}`
    );
  }

  public createAcknowledgement(taskId: string): Observable<TaskDescriptionAcknowledgementDTO> {
    return this.httpClient.post<TaskDescriptionAcknowledgementDTO>(
      `${environment.APIEndPoint}tasks/${taskId}/description-acknowledgements`,
      null,
      { responseType: 'json' }
    );
  }
}
